export default "__VITE_ASSET___Dw$bLie__"